// extracted by mini-css-extract-plugin
export default {"avatar":"_5D_GeEpq","avatar__icon":"_5DBv2eJF","avatar__img":"_5DXOsWK0","default":"_5DYqupq8","has-border":"_5DI1E0tO"};